export const MATCH_EDITOR_KIND = {
  date: 'date',
  number: 'number',
}

export const MATCH_EDITOR_KIND_BY_FIELD = {
  household_size: MATCH_EDITOR_KIND.number,
  intended_duration: MATCH_EDITOR_KIND.number,
  max_budget_warm: MATCH_EDITOR_KIND.number,
  move_in_date: MATCH_EDITOR_KIND.date,
}

export const MATCH_EDITOR_LIMITS_BY_FIELD = {
  household_size: { max: 20, min: 1 },
  intended_duration: { max: 120, min: 1 },
  max_budget_warm: { max: 100000, min: 0 },
}

export const QA_NAME_MATCH_EDITOR_INPUT = 'matchEditorInput'

export const QA_NAME_MATCH_EDITOR_SAVE = 'matchEditorSave'

export const QA_NAME_MATCH_EDITOR_CANCEL = 'matchEditorCancel'
